export const contingentDoneIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 11"><path d="M5.414 11a1 1 0 01-.707-.293L0 6l1.414-1.414 4 4 8-8L14.828 2l-8.707 8.707a1 1 0 01-.707.293z" fill="#1ABC9C"/></svg>`,
  name: 'done',
};
